<div
  class="track-descr"
  [ngClass]="{
    'track-descr--unavailable': isTrackInCart && !fixedBeat?.isOK,
    playing: status === PlayStatus.Playing
  }"
>
  @if (getTrackViewModel(); as trackViewModel) {
    @switch (parentComponent) {
      <!-- 🟦 Player Templates (desktop + mobile small/large) -->
      @case ('player') {
        <ng-container *ngTemplateOutlet="playerTemplate; context: { trackViewModel }"></ng-container>
      }
      @case ('player-mobSm') {
        <ng-container
          *ngTemplateOutlet="playerMobSmTemplate; context: { trackViewModel, titleClass: 'theme-player__beatName' }"
        ></ng-container>
      }
      @case ('player-mobLg') {
        <ng-container *ngTemplateOutlet="playerMobLgTemplate; context: { trackViewModel }"></ng-container>
      }
      <!-- 🟧 Share Track Popup -->
      @case ('share-track-popUp') {
        <ng-container *ngTemplateOutlet="sharePopupTemplate; context: { trackViewModel }"></ng-container>
      }
      <!-- 🟨 Track in Cart Popup -->
      @case ('track-in-cart-popUp') {
        <ng-container *ngTemplateOutlet="cartPopupTemplate; context: { trackViewModel }"></ng-container>
      }
      <!-- 🟩 Default Case -->
      @default {
        <ng-container *ngTemplateOutlet="defaultTemplate; context: { trackViewModel }"></ng-container>
      }
    }
  }
</div>

<!-- 🧩 TEMPLATES -->

<!-- 🎵 Cover -->
<ng-template #trackCover let-trackViewModel="trackViewModel" let-imgClass="imgClass">
  <img
    loading="lazy"
    class="track-descr__cover-img {{ imgClass || '' }}"
    [src]="trackViewModel.images.thumbnail"
    [alt]="trackViewModel.title + ' cover'"
  />
</ng-template>

<!-- 🎤 Beatmaker/Artist name + dash -->
<ng-template #artistWithDash let-trackViewModel="trackViewModel">
  <a class="track-descr__name theme-beats__beat-name" [routerLink]="trackViewModel.artist.url">
    {{ trackViewModel.artist.name }}
  </a>
  <span>-</span>
</ng-template>

<!-- 🎤 Beatmaker/Artist name + verification icon -->
<ng-template #verifiedBeatmakerName let-trackViewModel="trackViewModel">
  <div class="track-descr__verified-name sub-content__item">
    <span class="theme-beats__beat-name" [routerLink]="trackViewModel.artist.url">
      {{ trackViewModel.artist.name }}
    </span>
    @if (trackViewModel.artist.beatmakerVerified && showVerificationIcon) {
      <bmcore-verify-icon
        class="track-descr__verification-icon"
        [variant]="'svg'"
        [height]="verificationIconSize"
        [width]="verificationIconSize"
      ></bmcore-verify-icon>
    }
  </div>
</ng-template>

<!-- 📝 Track title -->
<ng-template #trackTitle let-trackViewModel="trackViewModel" let-titleClass="titleClass">
  <a
    class="track-descr__name bm--cut theme-beats__beat-name {{ titleClass || '' }}"
    [class.track-descr__name--player]="parentComponent === 'player'"
    [routerLink]="trackViewModel.url"
    (click)="handleTrackNameClick($event)"
    [ngClass]="{ disabled: appType === 'WIDGET' }"
  >
    {{ trackViewModel.title }}
  </a>
</ng-template>

<!-- TODO: This isn't used now, so it should be removed during refactoring -->
<!-- 🎼 Style/Genre, mood, bpm -->
<ng-template #styleAndMood let-trackViewModel="trackViewModel" let-descrClass="descrClass">
  <p class="track-descr__style theme-beats__beat-descr {{ descrClass || '' }}">
    {{ getStyleAndMood() }}
    @if (trackViewModel.bpm) {
      , {{ trackViewModel.bpm }} bpm
    }
  </p>
</ng-template>

<!-- Track metadata: 🎼 Style/Genre | 💭 Mood | ⏱️ BPM -->
<ng-template #trackStyleTemplate let-trackViewModel="trackViewModel">
  @if (trackViewModel.style?.title) {
    <span class="sub-content__item">
      {{ trackViewModel.style?.title }}
    </span>
  }
</ng-template>
<ng-template #trackMoodTemplate let-trackViewModel="trackViewModel">
  @if (trackViewModel.mood?.title) {
    <span class="sub-content__item">
      {{ trackViewModel.mood?.title }}
    </span>
  }
</ng-template>
<ng-template #trackBpmTemplate let-trackViewModel="trackViewModel">
  @if (trackViewModel.bpm) {
    <span class="sub-content__item"> {{ trackViewModel.bpm }} {{ lg.tracksBlock.bpm }} </span>
  }
</ng-template>

<!-- 🎯 Track Marker -->
<ng-template #trackMarker>
  @if (appType !== 'WIDGET' && parentComponent !== 'track-in-cart-popUp') {
    @if (parentComponent !== 'player-mobLg' && parentComponent !== 'player-mobSm') {
      <bmcore-track-marker
        class="track-descr__marker_hover"
        [ordinalNumber]="ordinalNumber"
        [isPromo]="isPromoTrack"
        [currencySign]="currencySign"
      ></bmcore-track-marker>
    }
  }
</ng-template>

<!-- 📦 DEFAULT TEMPLATE -->
<ng-template #defaultTemplate let-trackViewModel="trackViewModel">
  <ng-container *ngTemplateOutlet="trackMarker"></ng-container>

  <ng-container *ngTemplateOutlet="trackCover; context: { trackViewModel }"></ng-container>

  <div class="track-descr__content">
    <ng-container
      *ngTemplateOutlet="trackTitle; context: { trackViewModel, titleClass: 'theme-player__beatName' }"
    ></ng-container>

    <div class="track-descr__sub-content">
      <ng-container *ngTemplateOutlet="verifiedBeatmakerName; context: { trackViewModel }"></ng-container>

      <ng-container *ngTemplateOutlet="trackStyleTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackMoodTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackBpmTemplate; context: { trackViewModel }"></ng-container>
    </div>
  </div>
  <!---->
</ng-template>

<!-- 🎧 PLAYER TEMPLATE -->
<ng-template #playerTemplate let-trackViewModel="trackViewModel">
  <ng-container *ngTemplateOutlet="trackCover; context: { trackViewModel }"></ng-container>

  <div class="track-descr__content">
    <ng-container
      *ngTemplateOutlet="trackTitle; context: { trackViewModel, titleClass: 'theme-player__beatName' }"
    ></ng-container>

    <div class="track-descr__sub-content">
      <ng-container *ngTemplateOutlet="verifiedBeatmakerName; context: { trackViewModel }"></ng-container>

      <ng-container *ngTemplateOutlet="trackStyleTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackMoodTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackBpmTemplate; context: { trackViewModel }"></ng-container>
    </div>
  </div>
</ng-template>

<!--📱PLAYER-MOB-SM -->
<ng-template #playerMobSmTemplate let-trackViewModel="trackViewModel" let-titleClass="titleClass">
  <div class="track-descr__content">
    <!-- Code below duplicates since player-mobSm requires simple text. -->
    <!-- TODO: Needs to find a better solution -->
    <p
      class="track-descr__name bm--cut theme-beats__beat-name {{ titleClass || '' }}"
      [class.track-descr__name--player-mob-sm]="parentComponent === 'player-mobSm'"
      [ngClass]="{ disabled: appType === 'WIDGET' }"
    >
      {{ trackViewModel.title }}
    </p>

    <div class="track-descr__sub-content">
      <div class="track-descr__verified-name sub-content__item">
        <span class="theme-beats__beat-name">
          {{ trackViewModel.artist.name }}
        </span>
        @if (trackViewModel.artist.beatmakerVerified && showVerificationIcon) {
          <bmcore-verify-icon
            class="track-descr__verification-icon"
            [variant]="'svg'"
            [height]="verificationIconSize"
            [width]="verificationIconSize"
          ></bmcore-verify-icon>
        }
      </div>
    </div>
  </div>
</ng-template>

<!-- 📱 PLAYER-MOB-LG TEMPLATE -->
<ng-template #playerMobLgTemplate let-trackViewModel="trackViewModel">
  <div class="track-descr__content" [class.track-descr__content--player-mob-lg]="parentComponent === 'player-mobLg'">
    <ng-container
      *ngTemplateOutlet="trackTitle; context: { trackViewModel, titleClass: 'theme-player__beatName' }"
    ></ng-container>

    <div class="track-descr__sub-content">
      <ng-container *ngTemplateOutlet="trackStyleTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackMoodTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackBpmTemplate; context: { trackViewModel }"></ng-container>
    </div>
  </div>
</ng-template>

<!-- 🗂️ SHARE POPUP -->
<ng-template #sharePopupTemplate let-trackViewModel="trackViewModel">
  <ng-container *ngTemplateOutlet="trackCover; context: { trackViewModel }"></ng-container>

  <div class="track-descr__content">
    <ng-container
      *ngTemplateOutlet="trackTitle; context: { trackViewModel, titleClass: 'theme-shareTrackPopup__beatName' }"
    ></ng-container>

    <div class="track-descr__sub-content 'theme-shareTrackPopup__beatDescr'">
      <ng-container *ngTemplateOutlet="verifiedBeatmakerName; context: { trackViewModel }"></ng-container>

      <ng-container *ngTemplateOutlet="trackStyleTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackMoodTemplate; context: { trackViewModel }"></ng-container>
      <ng-container *ngTemplateOutlet="trackBpmTemplate; context: { trackViewModel }"></ng-container>
    </div>
  </div>
</ng-template>

<!-- 🛒 CART POPUP -->
<ng-template #cartPopupTemplate let-trackViewModel="trackViewModel">
  <ng-container
    *ngTemplateOutlet="trackCover; context: { trackViewModel, imgClass: 'track-descr__cover-img--cart-popup' }"
  ></ng-container>

  <div class="track-descr__content">
    <ng-container
      *ngTemplateOutlet="trackTitle; context: { trackViewModel, titleClass: 'theme-cartPopup__beatName' }"
    ></ng-container>

    <div class="track-descr__sub-content">
      <ng-container *ngTemplateOutlet="verifiedBeatmakerName; context: { trackViewModel }"></ng-container>

      <p class="sub-content__item theme-cartPopup__beatDescr">
        {{ trackViewModel.license?.title }}
      </p>
    </div>
  </div>
</ng-template>
